{
  "completed": "Завершено: ",
  "current": "Текущее: ",
  "notCompleted": "Не завершено: ",
  "steplist": "Список шагов"
}
